import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const returnsClaimsAnalyticsRoutes: PermissionedRouteObject[] = [
  {
    index: true,
    handle: {
      breadcrumb: "Returns & claims",
      permission: [ReturnsAndClaimsPermissions.VIEW_RETURN_AND_CLAIM_ANALYTICS],
    },
    async lazy() {
      const { ReturnClaimAnalytics } = await import("./return-claim-analytics");
      return { Component: ReturnClaimAnalytics };
    },
  },
  {
    path: "products/:productId",
    handle: {
      breadcrumb: "Details",
      permission: [ReturnsAndClaimsPermissions.VIEW_RETURN_AND_CLAIM_ANALYTICS],
    },
    async lazy() {
      const { ProductDetails } = await import("./product/product-details");
      return { Component: ProductDetails };
    },
  },
];
